import React, { useEffect } from "react";
import CaseList from "../components/CaseModule/CaseList";
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Divider,
  Tooltip,
  Button,
} from "@mui/material";
import {
  Edit,
  Add,
  History,
  AccountCircle,
  CalendarToday,
  Gavel,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const CaseListPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const token = Cookies.get("auth_token");
    if (!token) {
      setTimeout(() => {
        navigate("/login");
      }, 1000);
    }
  }, [navigate]);

  const enddate = "";
  // const today = new Date();
  // const dd = String(today.getDate()).padStart(2, "0");
  // const mm = String(today.getMonth() + 1).padStart(2, "0");
  // const yyyy = today.getFullYear();

  // const date = '';
  // const date = `${yyyy}/${mm}/${dd}`;
  const casestatus = [0];

  return (
    <CaseList
      Type={"List"}
      startdate={enddate}
      enddate={enddate}
      casestatusParam={casestatus}
      pageName={"Case Details"}
    />
  );
};

export default CaseListPage;
